<template>
        <Card>
            <template #title>
                <Toolbar>
                    <template #left>
                        <div class="p-card-title"> {{$t('progess_report_wo')}}</div>
                    </template>
                </Toolbar>
            </template>
            <template #content>
                <div class="p-inputtext-sm p-fluid">
                    <div class="grid">
                      <div class="col-12">
                            <FormField fieldName="No_Wo" :labelName="$t('no_wo')" v-model="header"
                                fieldClass="col-3" labelClass="col-2">
                                <CustomMultiSelect  v-if="header" name="No_Wo" 
                                            v-model="header.No_Wo"  
                                            :url="$API_URL + 'list/listWo'"
                                            :params="{ }" 
                                            :minLength="0" 
                                            :filter="true"
                                            :placeholder="$t('no_wo')"/>
                            </FormField>
                        </div>
                    </div>
                </div>
                <Button type="button" label="Generate" @click="getReport()" />
                &nbsp;
                <Button type="button" class="p-button-success" label="Reopen" @click="reopenTab()"
                    v-show="this.reportTbl" />
            </template>
        </Card>
    <ShowReport :isVisible="showReport" :reportTbl="this.reportTbl" @close="resetBtn()" />
</template>

<script type="text/javascript">
import ShowReport from "../Report/ShowReport.vue";
import FormField from "../Helper/FormField.vue";
export default {
    components: {
        ShowReport,
        FormField,
    },
    data() {
        return {
            test: 0,
            mode: "",
            dataUrl: "Report/progressreportwo",
            reportTbl: null,
            showReport: false,
            loadingReport: false,
            mergedOptions: [
                { label: "Y", value: 1 },
                { label: "N", value: 0 },
            ],
            header: {
                No_Wo: [],
                // Doc_Date_To: null,
                // Created_Date: null,
                // Created_Date_To: null,
                // Location_Code: null,
                // Department_Code: null,
                // Material_Code: null,
                // Created_By: null,
            },
             submitted :false
        };
    },
    methods: {
        reopenTab() {
            this.showReport = true;
        },
        resetBtn() {
            this.showReport = false;
        },
        tableToExcel() {
            this.loadingReport = !this.loadingReport;
        },
        getReport() {
            this.$emit('block-ui');
            this.$axios.post(this.$API_URL + this.dataUrl, this.header)
                .then((response) => {
                    this.reportTbl = {
                        header: response.data.data.header,
                        content: response.data.data.content,
                        title: response.data.data.title,
                    };
                    this.showReport = true;
                    this.$emit('unblock-ui');
                })
                .catch(() => {
                    this.$emit('unblock-ui');
                });
        },
        showError() {
            this.loadingReport = !this.loadingReport;
        },
        closeReport() {
            this.showReport = false;
        },
    },
    mounted() { },
     computed : {
           years() {
            let years = [];
            for (var i = 2022; i <= new Date().getFullYear(); i++) {
                years.push({ value: i.toString() })
            }
            return years;
        },
    }
};
</script>
